import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const isIos = () =>
  typeof navigator !== "undefined" &&
  /iphone|ipad|ipod/i.test(navigator.userAgent) &&
  !/crios|fxios/i.test(navigator.userAgent);

export const isStandalone = () =>
  typeof window !== "undefined" &&
  ((window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true);

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export const notifPermission = () =>
  typeof Notification !== "undefined" ? Notification.permission : "default";

const urlB64ToUint8Array = (base64) => {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(b64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const getPushSubscription = async () => {
  if (!pushSupported()) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    return await reg.pushManager.getSubscription();
  } catch {
    return null;
  }
};

/** Pide permiso, se suscribe (VAPID) y guarda la suscripción en backend.
 *  Devuelve { ok: bool, reason?: 'ios-install'|'unsupported'|'denied'|'error' } */
export const enablePush = async (token) => {
  if (isIos() && !isStandalone()) return { ok: false, reason: "ios-install" };
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  try {
    const perm = await Notification.requestPermission();
    if (perm !== "granted") return { ok: false, reason: "denied" };
    const { data } = await axios.get(`${BACKEND}/api/public/push/vapid-public-key`);
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.key),
    });
    await axios.post(`${BACKEND}/api/public/trip/${token}/push/subscribe`, sub.toJSON());
    return { ok: true };
  } catch {
    return { ok: false, reason: "error" };
  }
};
